import src from "IMAGE";
export default { src, width: 175, height: 68, blurWidth: 0, blurHeight: 0};
